// 介錯の武器の長さと太さを待機の絵 (idle) に揃えた8枚 (2026-10-19)。
//   刃の絵 6枚・砲の絵 2枚。体の画素は元の絵のまま、武器だけを伸ばし・細めた (長さ・太さとも idle の ±3% 以内・測定)。
//   配布版の既定 = 直した絵 (ファイルの幹 <key>_wfix・sprites.ts の SPRITE_FILE_OVERRIDE の初期値が持つ)。
//   旧の絵 (<key>.webp/.png) は同じ場所に残してある。DEV の ?execWeapon=old で旧へ戻して見比べる (game.ts の DEV ブロック)。
//   当たり・タイミングは変えていない (描く絵だけ)。記録 = docs/research/2026-10-19-executioner-weapon-fix.md。
//   ⚠️ このファイルは何も import しない (sprites.ts がモジュールの初期化中に読むため・循環させない)。
export const EXEC_WEAPON_FIX_KEYS: readonly (readonly ['blade' | 'cannon', string])[] = [
  ['blade', 'slam_windup'],
  ['blade', 'slam_hold'],
  ['blade', 'overhead_recover'],
  ['blade', 'quake_contact'],
  ['blade', 'overhead_contact'],
  ['blade', 'sweep_coil'],
  ['cannon', 'mortar_aim'],
  ['cannon', 'mortar_fire'],
  // 2026-10-31 砲の口の襟 (待機・戻りにある「広がる砲口と短い棘」) を、致命「執行」の3枚に描き足した (作者 10-30「襟＝A」)。
  //   砲口の周りだけ描き直し、体の画素は元の絵のまま。棘が元の枠の外へ出るので枠を広げた
  //   (元の絵の (0,0) が新しい絵のどこにあるか = sprites.ts EXEC_WEAPON_FIX_BODY_BOUNDS の origin)。
  //   記録 = docs/research/2026-10-31-cannon-collar.md。
  ['cannon', 'overhead_raise'],
  ['cannon', 'downswing_smear'],
  ['cannon', 'exec_contact'],
]

/** DEV の URL の値。'old' の時だけ旧の絵へ戻す (それ以外・指定なしは直した絵 = 配布版)。 */
export function execWeaponFixOn(param: string | null): boolean {
  return param !== 'old'
}
